/** @format */

import React, { useEffect, useState } from 'react';
import '../../css/methods/Description.css';

import Image from 'react-image-webp';

import image1 from '../../images/study-method/description1.jpeg';
import imageWebp1 from '../../images/study-method/description1.webp';

import image2 from '../../images/study-method/description2.jpg';
import imageWebp2 from '../../images/study-method/description2.webp';

import { IoBulbOutline, IoPaperPlaneOutline, IoCogOutline, IoSchoolOutline } from 'react-icons/io5';

const Description = () => {
	const [active, setActive] = useState(false);

	useEffect(() => {
		setTimeout(() => {
			setActive(true);
		}, 100);
	}, [active]);

	const handleLink = (e) => {
		e.preventDefault();
		const target = e.target.getAttribute('href');
		const location = document.querySelector(target).offsetTop;
		window.scrollTo({
			left: 0,
			top: location - 80,
		});
	};

	return (
		<div className='Description' style={active ? { opacity: 1 } : { opacity: 0 }}>
			<div className='description-content'>
				<div className='description-content-header'>
					<h2 className='description-content-title' style={{ fontSize: 28 }}>
						Escultura de personajes en Blender + proceso de impresión 3D
					</h2>
					<div className='description-content-separator'></div>
				</div>
				<p>
					En este grandioso entrenamiento podrás aprender a crear personajes en BLENDER desde cero
					con todo su proceso de preparación para imprimirlo en 3D en resina.
				</p>
				<ul>
					<li>
						<IoBulbOutline className='description-icon' />
						Entrenamientos especializados
					</li>
					<li>
						<IoPaperPlaneOutline className='description-icon' />
						Inicia tu curso de aprendizaje guiado
					</li>
					<li>
						<IoCogOutline className='description-icon' />
						Usaremos la última versión de Blender
					</li>
					<li>
						<IoSchoolOutline className='description-icon' />
						Se obtiene un nivel intermedio en Escultura para Impresión 3D con Blender
					</li>
				</ul>
				<a href='#contenido' onClick={handleLink} className='button-description'>
					Ver entrenamientos
				</a>
			</div>
			<div className='description-images-container'>
				<div className='description-image image-description-up'>
					<Image src={image1} webp={imageWebp1} />
				</div>
				<div className='description-image image-description-down'>
					<Image src={image2} webp={imageWebp2} />
				</div>
			</div>
		</div>
	);
};

export default Description;
